import React from "react";
import SearchField from "../SearchField/SearchField";
import useUSPosition from "../../hooks/useUSPosition";
import useUSUndo from "../../hooks/useUSUndo";
import USPositionFormGroup from "./USPositionFormGroup";
import { handleInputSelect, addEdits } from "./utils/inputhandlers";

const PositionsUSAStorage = ({ clearfield }) => {
  // Load context values
  const { USposition, setUSposition, setUSpositionData } = useUSPosition();
  const { positionEdits, editID, setEditID, undoList } = useUSUndo();
  return (
    <fieldset>
      <legend>Storage Details:</legend>
      <div className='form-group'>
        <label>Warehouse:</label>
        <SearchField
          required={true}
          searchURL='/api/positions/getUSwarehouses'
          value={USposition.warehouse || ""}
          valueName='warehouse'
          valueID='warehouseID'
          customplaceholder='warehouse...'
          onItemSelect={(item) => {
            handleInputSelect(
              item,
              positionEdits,
              editID,
              setEditID,
              setUSposition,
              setUSpositionData,
              addEdits,
              undoList,
              "warehouse",
              "warehouse"
            );
          }}
          style={{ textAlign: "left" }}
          clearfield={clearfield}
        />
      </div>
      <USPositionFormGroup
        type={"date"}
        labelname={"Entry Date"}
        inputname={"whentrydate"}
        inputtype={"text"}
        style={{ textAlign: "left" }}
      />
      <USPositionFormGroup labelname={"Fixed Cost"} inputname={"whfixedcost"} inputtype={"currency"} />
      <USPositionFormGroup labelname={"Variable Cost ($/pallet)"} inputname={"whvarcost"} inputtype={"currency"} />
      <USPositionFormGroup labelname={"Grace Period (days)"} inputname={"whgraceperiod"} inputtype={"integer"} />
      <USPositionFormGroup labelname={"Accrual Period (days)"} inputname={"whaccrualperiod"} inputtype={"integer"} />
    </fieldset>
  );
};

export default PositionsUSAStorage;
